import { userKeys } from './keys'
import { useQuery } from '@tanstack/react-query'
import { getIntercomJwt } from 'api/user'
import { QueryOptions } from 'queries/types'

export function useIntercomJwt(
  userId?: string,
  options: QueryOptions<typeof getIntercomJwt> = {}
) {
  return useQuery({
    ...options,
    queryKey: userKeys.intercomJwt(userId),
    queryFn: getIntercomJwt,
    enabled: !!userId,
  })
}
